// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabPanel-module__Container__OJK9X {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.TabPanel-module__Container__OJK9X:focus-visible {
    outline: var(--ds-tab-focus-outline-color) solid
        var(--ds-border-width-focus);
    outline-offset: calc(var(--ds-05x) * -1);
}

.TabPanel-module__ScrollableY__gOFN1 {
    overflow-y: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `TabPanel-module__Container__OJK9X`,
	"ScrollableY": `TabPanel-module__ScrollableY__gOFN1`
};
export default ___CSS_LOADER_EXPORT___;
